import { TranslationMap } from '@trimble-gcs/i18n-types';

export function ingestionProgressTranslations() {
  return {
    minutesRemaining: {
      lessThanMinute: {
        text: $localize`:@@ingestionProgress.minutesRemaining.lessThanMinute:less than a minute`,
        desc: 'Text for when the estimated time remaining is less than a minute.',
      },
      minutes: {
        text: $localize`:@@ingestionProgress.minutesRemaining.minutes:{minutes} minutes`,
        desc: 'Text for when the estimated time remaining is more than a minute.',
      },
    },
    tooltip: {
      progress: {
        percentageComplete: {
          text: $localize`:@@ingestionProgress.tooltip.progress.percentageComplete:Ingestion progress: {percentageComplete}%`,
          desc:
            'Line 1 of the Tooltip on the ingestion progress bar when ingestion workflow ' +
            'has moved out of queued status and is busy running.',
        },
        minutesRemaining: {
          text: $localize`:@@ingestionProgress.tooltip.progress.minutesRemaining:Estimated time remaining: {minutesRemaining}`,
          desc:
            'Line 2 of the Tooltip on the ingestion progress bar when ingestion workflow ' +
            'has moved out of queued status and is busy running.',
        },
      },
      queued: {
        text: $localize`:@@ingestionProgress.tooltip.queued:Queued...`,
        desc:
          'Tooltip on the ingestion progress bar when ingestion workflow ' +
          'has been queued, but not yet started.',
      },
    },
  } satisfies TranslationMap;
}
